'use client';

import Alert from '@components/Alert';
import Button from '@components/Button';
import Skeleton from '@components/Skeleton';
import Stack from '@components/Stack';
import Typography from '@components/Typography';
import { useNavigation } from '@hooks/useNavigation';
import type { NextPage } from 'next';
import { getProviders, signIn } from 'next-auth/react';
import { useEffect, useState } from 'react';

const Page: NextPage = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [providers, setProviders] = useState<Record<string, any> | null>(null);
  const {
    searchParams: { error, callbackUrl = '/' },
  } = useNavigation();

  useEffect(() => {
    setLoading(true);

    getProviders()
      .then((res) => {
        setProviders(res);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Typography variant="Title 20 - Standard">Continue with...</Typography>

      {error && (
        <Alert severity="error" title="Authentication failed">
          {error}
        </Alert>
      )}

      {!providers ? (
        <Stack gap={8} fullWidth>
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} style={{ height: 24 }}></Skeleton>
          ))}
        </Stack>
      ) : (
        Object.values(providers).map((provider: any) => (
          <Button
            disabled={loading}
            key={provider.name}
            variant="contained"
            onClick={() => {
              setLoading(true);
              signIn(provider.id, { callbackUrl });
            }}
          >
            {provider.name}
          </Button>
        ))
      )}
    </>
  );
};

export default Page;
